import { FormControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";
import { UtilityFunctions } from "./functions.models";

export class CustomValidator {

  public static email(): ValidatorFn {
    return (control: FormControl): ValidationErrors | null => {
      const email = control.value;
      if (email && !UtilityFunctions.isEmailValid(email)) {
        return { email: true };
      }
      return null;
    };
  }

  public static checkOnlyProp1OrProp2(nameProp1: string, nameProp2: string, namePropError): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const prop1 = control.get(nameProp1).value;
      const prop2 = control.get(nameProp2).value;
      if (prop1 && prop2) {
        return { [namePropError]: true };
      }
      return null;
    };
  }

  public static noWhitespaceValidator(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      return (control.value || '').trim().length === 0 ? { 'whitespace': true } : null;
    };
  }

  public static prop1IsValidWhenProp2IsValorized(nameProp1: string, nameProp2: string, namePropError): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      const prop1 = control.get(nameProp1).value;
      const prop2 = control.get(nameProp2).value;
      if (prop1 && !prop2) {
        return { [namePropError]: true };
      }
      return null;
    };
  }

  public static positiveNumberValidator(): ValidatorFn {
    return (control: FormGroup): ValidationErrors | null => {
      return control.value >= 0 ? null : { positiveNumber: true };
    };
  }

  public static dateRangeValidator(dateControlName: string, minControlName: string, maxControlName: string): ValidatorFn {
    return (formGroup: FormGroup): ValidationErrors | null => {
      const minDateControl = formGroup.get(minControlName);
      const maxDateControl = formGroup.get(maxControlName);
      const dateControl = formGroup.get(dateControlName);
      if (dateControl && dateControl.value) {
        const date = new Date(dateControl.value).setHours(0, 0, 0, 0);
        const min = minDateControl.value ? new Date(minDateControl.value).setHours(0, 0, 0, 0) : null;
        const max = maxDateControl.value ? new Date(maxDateControl.value).setHours(0, 0, 0, 0) : null;

        if (min && date < min) {
          return { dateRange: 'Date is before the minimum allowed date.' };
        } else if (max && date > max) {
          return { dateRange: 'Date is after the maximum allowed date.' };
        } else {
          return null;
        }
      }

      return null;
    };
  }
}
